module.exports = __webpack_public_path__ + "img/logo.6a884589.png";